// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import '@styles/webdesktop/stylesheets/numericUpDownButton.scss';
import React from 'react';
import { SvgIconType } from '../../../SvgIcon/SvgIconType';
import { SvgIcon } from '../../../SvgIcon/SvgIcon';
import { Size } from '@front/sharedcomponents/Variables';
export const NumericUpDownButton = (_a) => {
    var { isUp, onPointerDown, onPointerUp, onPointerLeave, onPointerCancel } = _a, restProps = __rest(_a, ["isUp", "onPointerDown", "onPointerUp", "onPointerLeave", "onPointerCancel"]);
    return (React.createElement("button", Object.assign({ className: `numeric-up-down-button ${isUp ? 'up' : 'down'}`, onPointerDown: onPointerDown, onPointerUp: onPointerUp, onPointerLeave: onPointerLeave, onPointerCancel: onPointerCancel, tabIndex: -1 }, restProps),
        React.createElement(SvgIcon, { icon: isUp ? SvgIconType.ArrowUp : SvgIconType.ArrowDown, size: Size.None })));
};
